export default {"src":"/_next/static/media/secure.f5f41e3e.svg","height":41,"width":31};